import { __assign, __extends, __rest, __spreadArrays } from "tslib";
import React from 'react';
import classNames from 'classnames';
import Draggable from './utils/Draggable';
import DialogContent from './DialogContent';
import DialogTitle from './DialogTitle';
import DialogActions from './DialogActions';
import Button from '../Button';
import Fade from '../transitions/Fade';
import StyledDialog from './StyledDialog';
import CloseIcon from './CloseIcon';
import Iframe from './Iframe';
function wrapTextContent(children, props) {
    return React.Children.toArray(children).map(function (node) {
        if (typeof node === 'string') {
            return (React.createElement(DialogContent, { key: "dialogContent", type: "subheading" }, node));
        }
        if (node.type && node.type.sinouiName === 'DialogTitle') {
            return (React.createElement(DialogTitle, __assign({ key: "dialogTitle" }, node.props, { showCloseIcon: props.showCloseIcon }),
                node.props.children,
                props.showCloseIcon && React.createElement(CloseIcon, { onClick: props.onRequestClose })));
        }
        return node;
    });
}
/**
 * children中是否包含指定组件类型的子组件
 *
 * @param {Node} children
 * @param {ComponentType} nodeType
 */
function isContain(children, 
// tslint:disable-next-line:no-any
nodeType) {
    var contain = false;
    // tslint:disable-next-line:no-any
    React.Children.forEach(children, function (node) {
        if (contain === false && node && node.type === nodeType) {
            contain = true;
        }
    });
    return contain;
}
/**
 * 获取Dialog子组件的排序号
 *
 * @param {Node} node
 */
// tslint:disable-next-line:no-any
function getDialogNodeOrderNode(node) {
    switch (node.type) {
        case DialogTitle:
            return 0;
        case DialogActions:
            return 2;
        default:
            return 1;
    }
}
function sortDialogChildren(
// tslint:disable-next-line:no-any
node1, 
// tslint:disable-next-line:no-any
node2) {
    // 标题、内容、actions，编排序号：0， 1， 2
    return getDialogNodeOrderNode(node1) - getDialogNodeOrderNode(node2);
}
var DialogContainer = /** @class */ (function (_super) {
    __extends(DialogContainer, _super);
    function DialogContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialogContainerRef = React.createRef();
        return _this;
    }
    DialogContainer.prototype.componentDidMount = function () {
        if (this.props.draggable) {
            this.draggable = new Draggable({
                container: this.dialogContainerRef.current,
                handler: '.sinoui-dialog-title',
                bounds: true,
            });
        }
    };
    DialogContainer.prototype.componentWillUnmount = function () {
        if (this.draggable) {
            this.draggable.teardown();
        }
    };
    DialogContainer.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, title = _a.title, children = _a.children, content = _a.content, _b = _a.actions, _actions = _b === void 0 ? [] : _b, ok = _a.ok, cancel = _a.cancel, onOk = _a.onOk, onCancel = _a.onCancel, okName = _a.okName, cancelName = _a.cancelName, column = _a.column, fullScreen = _a.fullScreen, fullWidth = _a.fullWidth, _c = _a.transition, Transition = _c === void 0 ? Fade : _c, transitionDuration = _a.transitionDuration, autoWidth = _a.autoWidth, showCloseIcon = _a.showCloseIcon, disabled = _a.disabled, _d = _a.backdropClick, backdropClick = _d === void 0 ? false : _d, rest = __rest(_a, ["className", "style", "title", "children", "content", "actions", "ok", "cancel", "onOk", "onCancel", "okName", "cancelName", "column", "fullScreen", "fullWidth", "transition", "transitionDuration", "autoWidth", "showCloseIcon", "disabled", "backdropClick"]);
        var actions = __spreadArrays(_actions);
        if (cancel) {
            var buttonMessage = cancelName || '取消';
            actions.push(React.createElement(Button, { onClick: onCancel, key: "cancelButton" }, buttonMessage));
        }
        if (ok) {
            var buttonMessage = okName || '确定';
            actions.push(React.createElement(Button, { disabled: disabled, onClick: onOk, key: "okButton" }, buttonMessage));
        }
        var nodes = __spreadArrays([
            title && !isContain(children, DialogTitle) && (React.createElement(DialogTitle, { key: "dialogTitle", type: "title", showCloseIcon: showCloseIcon },
                title,
                showCloseIcon && React.createElement(CloseIcon, { onClick: this.props.onRequestClose }))),
            content && !isContain(children, DialogContent) && (React.createElement(DialogContent, { key: "dialogContent", type: "subheading" }, content)),
            actions.length > 0 && !isContain(children, DialogActions) && (React.createElement(DialogActions, { key: "dialogActions", column: column }, actions))
        ], wrapTextContent(children, this.props)).filter(Boolean)
            .sort(sortDialogChildren);
        return (React.createElement(StyledDialog, { fullScreen: fullScreen, fullWidth: fullWidth, className: classNames('sinoui-dialog', className), style: style, autoWidth: autoWidth, ref: this.dialogContainerRef },
            nodes,
            this.props.containsIframe && (React.createElement(Iframe, { frameBorder: 0, scrolling: "false", absolute: this.props.absolute }))));
    };
    DialogContainer.defaultProps = {
        containsIframe: true,
        draggable: true,
    };
    return DialogContainer;
}(React.Component));
export default DialogContainer;
//# sourceMappingURL=DialogContainer.js.map